'use client';

import type { ReactNode } from 'react';
import { InteractshRenderer } from '../../ToolCallsRenderers/renderers/InteractshRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderInteractshResult = (ctx: OutputRenderContext): ReactNode => {
  const { content } = ctx;

  return <InteractshRenderer data={content} />;
};
